<template>
  <div class="tickets-container">
    <!-- Título de la vista -->
    <h1 class="title">{{ $t('gestion_tickets') }}</h1>
    <h2 class="title">{{ $t('vista_tickets') }}</h2>

    <h1 style="color: red;">{{ $t('en_construccion') }}</h1>

    <!-- Botón de cerrar sesión -->
    <button class="logout-button" @click="logout">{{ $t('cerrar_sesion') }}</button>

    <!-- Opciones de categorías -->
    <select>
      <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
        {{ getCategoriaTraducida(cat.nombre) }}
      </option>
    </select>
  </div>
</template>

<script>
import api from '../api'; // Importar la instancia de Axios

export default {
  data() {
    return {
      categorias: [] // categorías cargadas desde la API
    };
  },
  async created() {
    await this.loadCategorias();
  },
  methods: {
    async logout() {
      try {
        // Llamar al endpoint de logout de la API
        await api.post('/logout');

        // Limpiar token y datos sesión en frontend
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('user_name');
  sessionStorage.removeItem('user_role');

        // Redirigir al login
        this.$router.push('/login');
      } catch (err) {
        const payload = err.response?.data || { message: err.message || 'Network error' };
        console.error('Error al cerrar sesión:', payload);
        // Notificar usuario de forma simple
        alert(payload.message || 'Error al cerrar sesión');
      }
    },
    getCategoriaTraducida(nombre) {
      const nombreClave = {
        "Hardware": "hardware",
        "Software": "software",
        "Redes y Conectividad": "redes",
        "Correo Electrónico": "correo",
        "Acceso y Contraseñas": "acceso",
        "Impresión y escaneo": "impresion",
        "Seguridad": "seguridad",
        "Telefonía": "telefonia",
        "Aplicaciones Web / Intranet": "web",
        "Otros": "otros"
      }[nombre] || nombre;
      return this.$t('categorias_traducidas.' + nombreClave) || nombre;
    },
    logCategoriaNombre(nombre) {
      // Sólo para debug en desarrollo
      if (import.meta.env.DEV) console.log('Valor recibido de categoría:', nombre);
      return '';
    },
    async loadCategorias() {
      try {
        const resp = await api.get('/tickets/categorias');
        // Adaptar según la estructura devuelta por la API
        this.categorias = resp.data?.categorias ?? resp.data ?? [];
        if (import.meta.env.DEV) console.log('Categorías cargadas:', this.categorias.length);
      } catch (err) {
        const payload = err.response?.data || { message: err.message || 'Network error' };
        console.error('Error al cargar categorías:', payload);
        this.categorias = [];
      }
    }
  }
};
</script>

<style scoped>
/* Contenedor principal */
.tickets-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Centrar verticalmente */
  background-color: #f8f9fa; /* Fondo claro */
  text-align: center;
  padding: 20px;
}

/* Estilo del título */
.title {
  font-size: 32px;
  font-weight: bold;
  color: #343a40; /* Gris oscuro */
  margin-bottom: 30px;
}

/* Estilo del botón de cerrar sesión */
.logout-button {
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #dc3545; /* Rojo Bootstrap */
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-button:hover {
  background-color: #c82333; /* Rojo más oscuro */
}
</style>